var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3125 17.5C6.425 21.8125 10.3375 25 15 25C20.525 25 25 20.525 25 15C25 9.475 20.525 5 15 5C12.0125 5 9.3375 6.3125 7.5 8.3875L5 11.25",
    stroke: "#666666",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66114 13H9.33753C9.92655 13 10.2215 12.2879 9.80503 11.8714L4.12863 6.19497C3.71214 5.77848 3 6.07345 3 6.66247V12.3389C3 12.704 3.296 13 3.66114 13Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/return.dfc1ad2fa1986267cd64a916078153c8.svg";
export { ForwardRef as ReactComponent };